import axios from 'axios'
import queryString from 'query-string'

let domain = window.location.hostname === 'localhost' ? 'dentclub.com.ua' : /(?<=\.).+/.exec(window.location.hostname)[0];
const baseUrl = 'https://api.'+domain+'/api/v1/';

const getToken = () => localStorage.getItem('token');

const axiosClient = axios.create({
  baseURL: baseUrl,
  paramsSerializer: params => queryString.stringify({ params })
});

axiosClient.interceptors.request.use(async config => {
  return {
    ...config,
    headers: {
      'Content-Type': 'application/json',
      'authorization': `Bearer ${getToken()}`
    }
  }
})

axiosClient.interceptors.response.use(response => {
  if (response && response.data) return response.data;
  return response
}, err => {
  if (!err.response) {
    return alert(err)
  }
  throw err.response
})

export default axiosClient